/**
 * @module views\mdl\equipment
 */
import Vue from "vue";
import Component from "vue-class-component";
import GhBase from "@/components/ghBase";
import { Watch, Mixins } from "vue-property-decorator";
import GhTablePage from "@/components/ghTablePage/ghTablePage";
import { TreeNode } from "element-ui/types/tree";

import { MethodService } from "../../../utils/serviceModel";
import DependedStructure from "../dependedStructure/dependedStructure";
@Component
export default class Equipment extends Mixins(DependedStructure) {
  protected module = "mes.business.mdl.equipment.service";
  protected cls = "EquipmentService";
}
